(function () {
    'use strict';

    angular
        .module('salesflare.components.workflowStepAnalytics', [
            'salesflare.components.workflowStepAnalytics.sendEmailAudience'
        ])
        .component('sfWorkflowStepAnalytics', {
            templateUrl: 'app-ajs/components/workflows/workflow/workflowstep/analytics/workflowStepAnalytics.html',
            controller,
            controllerAs: 'vm'
        });

    function controller($document, $state, $stateParams, $mdMedia, $mdDialog, $timeout, workflowService, contactsService, utils, $exceptionHandler, $translate) {

        const vm = this;
        let searchDebounce;
        let currentCount = $stateParams.currentCount || 0;

        vm.$mdMedia = $mdMedia;
        vm.insufficientPermissionsMessage = $translate.instant('You don\'t have permission to edit this workflow. Ask an admin.');

        vm.searchObject = {
            search: $stateParams.search,
            getSearch: function () {

                return this.search;
            },
            setSearch: function (s) {

                this.search = s;

                return utils.setSearchInUrl({ search: this.search });
            }
        };

        vm.searchMode = !!$stateParams.search;

        vm.$onInit = function () {

            // Set state params, workflow and workflowStep are only filled via the stateParams when changing tabs in the analytics view
            vm.workflowId = $stateParams.id;
            vm.viewingTab = $stateParams.viewing;
            vm.workflowStepId = Number.parseInt($stateParams.stepId);
            vm.workflow = $stateParams.workflow;
            vm.workflowStep = $stateParams.workflowStep;

            if (!vm.workflow || !vm.workflowStep) {
                return workflowService.get(vm.workflowId).then(function (response) {

                    vm.workflow = response.data;
                    vm.workflowStep = vm.workflow.steps.find(function (step) {

                        return step.id === vm.workflowStepId;
                    });

                    setDataWhenWorkflowStepAvailable();
                });
            }

            setDataWhenWorkflowStepAvailable();
        };

        vm.audience = {
            toLoad: 0,
            numLoaded: 0,
            items: [],
            topIndex: 0,

            getItemAtIndex: function (index) {

                if (index > this.numLoaded) {
                    this.fetchMoreItems(index);

                    return null;
                }

                return this.items[index];
            },

            getLength: function () {

                if (this.items.length < this.numLoaded) {
                    return this.items.length;
                }

                return this.numLoaded + 20;
            },

            fetchMoreItems: function (index) {

                if (this.toLoad < index) {
                    this.toLoad += 20;

                    const bound = angular.bind(this, audienceResponseHandler);

                    const filter = angular.copy(vm.viewingTabInfo.filter);

                    if (vm.searchObject.getSearch()) {
                        filter.search = vm.searchObject.getSearch();
                    }

                    const requestConfig = {
                        filter
                    };

                    if (this.items.length === 0) {
                        workflowService.getStepAudience(vm.workflowId, vm.workflowStepId, requestConfig, { returnCountOnly: true }).then(function (response) {

                            currentCount = Number.parseInt(response.headers('x-result-count'));
                        });
                        requestConfig.limit = this.toLoad;
                        return workflowService.getStepAudience(vm.workflowId, vm.workflowStepId, requestConfig).then(bound, null, bound);
                    }

                    requestConfig.limit = 20;
                    requestConfig.offset = this.numLoaded;

                    return workflowService.getStepAudience(vm.workflowId, vm.workflowStepId, requestConfig).then(angular.bind(this, function (response) {

                        this.items = [...this.items, ...response.data];
                        this.numLoaded = this.toLoad;
                    }));
                }
            },

            // Forces reset of object
            reload: function () {

                this.toLoad = 0;
                this.numLoaded = 0;
                this.items = [];
                this.doneLoading = false;
                this.topIndex = 0;
            }
        };

        function audienceResponseHandler(response) {

            this.items = response.data;
            this.numLoaded = this.toLoad;
            vm.showEmptyState = response.data.length === 0;
            this.doneLoading = true;
        }

        vm.doSearch = function (search) {

            vm.showEmptyState = false;
            $timeout.cancel(searchDebounce);

            searchDebounce = $timeout(function () {

                vm.searchObject.setSearch(search);

                return vm.audience.reload();
            }, 750);
        };

        vm.clearSearch = function () {

            // Don't execute debounced search if search cleared
            $timeout.cancel(searchDebounce);
            vm.searchObject.setSearch('');
            return vm.audience.reload();
        };

        vm.setSearchMode = function (mode) {

            if (vm.searchMode && !mode) {
                vm.searchMode = mode;

                if (!mode && vm.searchObject.getSearch()) {
                    // Since we're going to do a reload of the data, we don't know yet if we need to show the empty state
                    vm.showEmptyState = false;
                    return vm.clearSearch();
                }

                vm.searchObject.setSearch('');
            }

            vm.searchMode = mode;

            if (vm.searchMode) {
                utils.forceFocus($document[0].querySelector('#searchbox'));
            }
        };

        vm.back = function () {
            return $state.go('workflow', { id: $stateParams.id });
        };

        vm.selectTab = function (analyticName) {

            if (analyticName === vm.viewingTab) {
                return;
            }

            const filter = angular.copy(vm.stepInfo[analyticName][0].filter);

            const requestConfig = {
                filter
            };

            // Update count and refetch workflow step so analytics numbers update as well
            return workflowService.getStepAudience(vm.workflowId, vm.workflowStepId, requestConfig, { returnCountOnly: true }).then(function (countResponse) {

                return workflowService.get(vm.workflowId).then(function (response) {

                    return $state.go('workflow-stepAnalytics', {
                        id: $stateParams.id,
                        viewing: analyticName,
                        currentCount: Number.parseInt(countResponse.headers('x-result-count')),
                        workflow: response.data,
                        workflowStep: response.data.steps.find(function (step) {

                            return step.id === vm.workflowStepId;
                        })
                    });
                });
            });
        };

        vm.onSublistChange = function () {

            const filter = angular.copy(vm.viewingTabInfo.filter);

            if (vm.searchObject.getSearch()) {
                vm.searchObject.setSearch();
            }

            const requestConfig = {
                filter
            };

            return workflowService.getStepAudience(vm.workflowId, vm.workflowStepId, requestConfig, { returnCountOnly: true }).then(function (response) {

                currentCount = Number.parseInt(response.headers('x-result-count'));
                vm.audience.reload();
            });
        };

        // TODO: Make generic for different kind of workflow step actions
        vm.getTitle = function () {

            if (!vm.workflowStep || !vm.workflow) {
                return;
            }

            const stepName = vm.workflowStep.name;
            const count = currentCount;

            switch (vm.viewingTabInfo.id) {
                case 'total':
                    if (currentCount === 1) {
                        return $translate.instant('{{count}} contact has entered {{stepName}}', { count, stepName });
                    }

                    return $translate.instant('{{count}} contacts have entered {{stepName}}', { count, stepName });

                case 'sent':
                    if (currentCount === 1) {
                        return $translate.instant('{{stepName}} has been sent to {{count}} contact', { count, stepName });
                    }

                    return $translate.instant('{{stepName}} has been sent to {{count}} contacts', { count, stepName });

                case 'opened':
                    if (currentCount === 1) {
                        return $translate.instant('{{count}} contact has opened {{stepName}}', { count, stepName });
                    }

                    return $translate.instant('{{count}} contacts have opened {{stepName}}', { count, stepName });

                case 'not_opened':
                    if (currentCount === 1) {
                        return $translate.instant('{{count}} contact hasn\'t opened {{stepName}}', { count, stepName });
                    }

                    return $translate.instant('{{count}} contacts haven\'t opened {{stepName}}', { count, stepName });

                case 'clicked':
                    if (currentCount === 1) {
                        return $translate.instant('{{count}} contact has clicked {{stepName}}', { count, stepName });
                    }

                    return $translate.instant('{{count}} contacts have clicked {{stepName}}', { count, stepName });

                case 'not_clicked':
                    if (currentCount === 1) {
                        return $translate.instant('{{count}} contact hasn\'t clicked {{stepName}}', { count, stepName });
                    }

                    return $translate.instant('{{count}} contacts haven\'t clicked {{stepName}}', { count, stepName });

                case 'replied':
                    if (currentCount === 1) {
                        return $translate.instant('{{count}} contact has replied to {{stepName}}', { count, stepName });
                    }

                    return $translate.instant('{{count}} contacts have replied to {{stepName}}', { count, stepName });

                case 'not_replied':
                    if (currentCount === 1) {
                        return $translate.instant('{{count}} contact hasn\'t replied to {{stepName}}', { count, stepName });
                    }

                    return $translate.instant('{{count}} contacts haven\'t replied to {{stepName}}', { count, stepName });

                case 'failed':
                    if (currentCount === 1) {
                        return $translate.instant('{{stepName}} has failed to send to {{count}} contact', { count, stepName });
                    }

                    return $translate.instant('{{stepName}} has failed to send to {{count}} contacts', { count, stepName });

                case 'not_failed':
                    if (currentCount === 1) {
                        return $translate.instant('{{stepName}} hasn\'t failed to send to {{count}} contact', { count, stepName });
                    }

                    return $translate.instant('{{stepName}} hasn\'t failed to send to {{count}} contacts', { count, stepName });

                case 'unsubscribed':
                    if (currentCount === 1) {
                        return $translate.instant('{{count}} contact has unsubscribed from {{stepName}}', { count, stepName });
                    }

                    return $translate.instant('{{count}} contacts have unsubscribed from {{stepName}}', { count, stepName });

                case 'not_unsubscribed':
                    if (currentCount === 1) {
                        return $translate.instant('{{count}} contact hasn\'t unsubscribed from {{stepName}}', { count, stepName });
                    }

                    return $translate.instant('{{count}} contacts haven\'t unsubscribed from {{stepName}}', { count, stepName });

                case 'bounced':
                    if (currentCount === 1) {
                        return $translate.instant('{{count}} contact\'s email bounced for {{stepName}}', { count, stepName });
                    }

                    return $translate.instant('{{count}} contacts\' emails bounced for {{stepName}}', { count, stepName });

                case 'not_bounced':
                    if (currentCount === 1) {
                        return $translate.instant('{{count}} contact\'s email hasn\'t bounced for {{stepName}}', { count, stepName });
                    }

                    return $translate.instant('{{count}} contacts\' emails haven\'t bounced for {{stepName}}', { count, stepName });
            }
        };

        vm.send = function () {

            // We need to include the 'internal' and 'query_builder_id' properties here for the humanReadableAdvancedFilter service to work correctly
            const filter = angular.copy(vm.viewingTabInfo.filter);
            filter.rules.push({
                id: 'workflow.step.id',
                query_builder_id: 'workflow_step_record.workflow_step',
                operator: 'equal',
                value: [vm.workflowStep.id],
                internal: true
            });

            return $state.go('composeWorkflow', {
                filter,
                disableEditFilter: true,
                filterText: getFilterText()
            });
        };

        function getFilterText() {

            switch (vm.viewingTabInfo.id) {
                case 'sent':
                    return $translate.instant('All contacts receiving the email');
                case 'opened':
                    return $translate.instant('Contacts who have opened this email');
                case 'not_opened':
                    return $translate.instant('Contacts who haven\'t opened this email');
                case 'clicked':
                    return $translate.instant('Contacts who have clicked this email');
                case 'not_clicked':
                    return $translate.instant('Contacts who haven\'t clicked this email');
                case 'replied':
                    return $translate.instant('Contacts who have replied to this email');
                case 'not_replied':
                    return $translate.instant('Contacts who haven\'t replied to this email');
                default: {
                    const error = new Error('No filtertext match for "' + vm.viewingTabInfo.id + '"');
                    error.tabInfo = vm.viewingTabInfo;
                    $exceptionHandler(error);
                    return '';
                }
            }
        }

        vm.export = function (type) {

            if (!vm.workflowStep) {
                return;
            }

            const filter = angular.copy(vm.viewingTabInfo.filter);
            filter.rules.push({
                id: 'workflow.step.id',
                operator: 'equal',
                value: [vm.workflowStep.id]
            });

            if (vm.workflow.record_type === 'contact') {
                const filterGetOptions = {
                    filterRules: filter,
                    limit: 100000,
                    offset: 0,
                    downloadCSV: type === 'csv',
                    downloadExcel: type === 'excel'
                };

                const exportFieldsDialog = $mdDialog.exportFieldsDialog({
                    locals: {
                        entity: 'contacts'
                    },
                    fullscreen: !$mdMedia('gt-sm')
                });

                return $mdDialog.show(exportFieldsDialog).then(function (exportConfig) {
                    filterGetOptions.exportFields = exportConfig.exportFields;

                    return contactsService.filterGet(filterGetOptions);
                });
            }
        };

        // Execute when vm.workflow and vm.workflowStep are initialized
        function setDataWhenWorkflowStepAvailable() {

            vm.stepInfo = workflowService.getActionTypeTabInfo(vm.workflowStep.action_type);
            vm.analytics = workflowService.prepareAnalyticData(vm.workflowStep.analytics);
            vm.viewingTabInfo = vm.stepInfo[vm.viewingTab][0];
            // TODO: Remove and handle in service to generalize the implementation
            vm.trackingEnabled = vm.workflowStep.action_config.message.tracked;
        }
    }
})();
